/**
 * Gets element that currently has focus with support for open shadow roots.
 * @param root Optional container to search for the active element. Defaults to `document`.
 * @returns The Element within the DOM that currently has focus.
 */
const getActiveElement = (root: DocumentOrShadowRoot = document): Element | null => {
  let activeEl = root.activeElement;

  if (!activeEl) return null;

  if (
    activeEl.tagName.toLowerCase() === 'iframe' &&
    (activeEl as HTMLIFrameElement).contentDocument
  )
    activeEl = getActiveElement((activeEl as HTMLIFrameElement).contentDocument!) ?? activeEl;

  if (activeEl.shadowRoot) activeEl = getActiveElement(activeEl.shadowRoot) ?? activeEl;

  return activeEl;
};

export default getActiveElement;
